import { DismissCloneJobRequestSchema, DismissCloneJobResponseSchema } from './dismiss-clone-job.schema';
/**
 * Dismiss Clone Job Endpoint Contract
 * Acknowledges a clone job and clears it WITHOUT rolling anything back.
 * Restricted to super-admins.
 *
 * Dismissing is not cancelling. A `running` job is refused (409): its detached
 * worker is still writing heartbeats and job transitions, and deleting the
 * document out from under it would silently blind the reaper to work still in
 * flight while leaving the admin with no way to see it.
 */ export const dismissCloneJobContract = {
    method: 'DELETE',
    path: '/api/v2/tenant-clone-jobs/:jobId',
    description: 'Clear a tenant clone job without rolling back the clone (super-admin only)',
    requestSchema: DismissCloneJobRequestSchema,
    responseSchema: DismissCloneJobResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid job id',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Clone job not found',
            409: 'The job is still running - dismissing is not cancelling'
        }
    }
};

//# sourceMappingURL=dismiss-clone-job.contract.js.map